import { ComponentType, SVGProps } from "react";
import { ReactComponent as ChartIcon } from "assets/icons/chart-icon.svg";
import { ReactComponent as OrdersIcon } from "assets/icons/orders-icon.svg";
import { ReactComponent as HistoryIcon } from "assets/icons/history-icon.svg";
import { ReactComponent as AdminPanelIcon } from "assets/icons/admin-panel-icon.svg";

interface IMenuItems {
  path: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
}

const menuItems: IMenuItems[] = [
  {
    path: "/orders",
    icon: OrdersIcon,
    title: "Замовлення",
  },
  {
    path: "/ordersStatistic",
    icon: ChartIcon,
    title: "Статистика замовлень",
  },
  {
    path: "/history",
    icon: HistoryIcon,
    title: "Історія",
  },
  {
    path: "/drivers",
    icon: AdminPanelIcon,
    title: "Адмін-панель",
  },
];
export default menuItems;
